/* unplugin-vue-components disabled */import { render } from "./tenant-ps.vue?vue&type=template&id=22773138&scoped=true"
import script from "./tenant-ps.vue?vue&type=script&lang=js"
export * from "./tenant-ps.vue?vue&type=script&lang=js"

import "./tenant-ps.vue?vue&type=style&index=0&id=22773138&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22773138"],['__file',"src/pages/tenants/settings/tenant-ps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22773138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22773138', __exports__)) {
    api.reload('22773138', __exports__)
  }
  
  module.hot.accept("./tenant-ps.vue?vue&type=template&id=22773138&scoped=true", () => {
    api.rerender('22773138', render)
  })

}


export default __exports__